<template>
  <div>
    <CreateNewMessageDialog
      :dialog="showCreateNewMessageDialog"
      :startDate="new Date().toISOString().substr(0, 10)"
      :endDate="new Date().toISOString().substr(0, 10)"
      :market="US"
      @close="closeCreateNewMessageDialog"
      ref="createNewMessageDialog"
    >
    </CreateNewMessageDialog>

    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>Messaging</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab @click="refreshTab('myDrafts')">My Drafts</v-tab>
            <v-tab @click="refreshTab('otherDrafts')">Other Drafts</v-tab>
            <v-tab @click="refreshTab('pendingApproval')">Pending Approval</v-tab>
            <v-tab @click="refreshTab('upcoming')">Upcoming</v-tab>
            <v-tab @click="refreshTab('active')">Active</v-tab>
            <v-tab @click="refreshTab('completed')">Completed</v-tab>
            <v-tab @click="refreshTab('deleted')">Deleted</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <MyDrafts ref="myDrafts"/>
        </v-tab-item>
        <v-tab-item>
          <OtherDrafts ref="otherDrafts"/>
        </v-tab-item>
        <v-tab-item>
          <PendingApproval ref="pendingApproval"/>
        </v-tab-item>
        <v-tab-item>
          <Upcoming ref="upcoming"/>
        </v-tab-item>
        <v-tab-item>
          <Active ref="active"/>
        </v-tab-item>
        <v-tab-item>
          <Completed ref="completed"/>
        </v-tab-item>
        <v-tab-item>
          <Deleted ref="deleted"/>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions style="position:absolute;bottom:0;right:0">
        <v-btn
          v-if="tab === 0"
          color="grey lighten-1"
          @click.stop="openCreateNewMessageDialog()"
        >
          Create New Message
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import MyDrafts from '../components/messaging/MyDrafts.vue';
import OtherDrafts from '../components/messaging/OtherDrafts.vue';
import PendingApproval from '../components/messaging/PendingApproval.vue';
import Upcoming from '../components/messaging/Upcoming.vue';
import Active from '../components/messaging/Active.vue';
import Completed from '../components/messaging/Completed.vue';
import Deleted from '../components/messaging/Deleted.vue';
import CreateNewMessageDialog from '../components/messaging/CreateNewMessageDialog.vue';

export default {
  components: {
    MyDrafts,
    OtherDrafts,
    PendingApproval,
    Upcoming,
    Active,
    Completed,
    Deleted,
    CreateNewMessageDialog,
  },

  data() {
    return {
      tab: 0,
      showCreateNewMessageDialog: false,
    };
  },

  methods: {
    openCreateNewMessageDialog() {
      // this.$refs.createNewMessageDialog.reset();
      this.showCreateNewMessageDialog = true;
    },

    closeCreateNewMessageDialog(reload) {
      this.showCreateNewMessageDialog = false;

      if (reload) {
        switch (this.tab) {
          case 0:
            console.log('need to reload MyDrafts component');
            this.$refs.myDrafts.getData();
            break;
        }
      }
    },

    refreshTab(tab) {
      if (this.$refs[tab]) {
        this.$refs[tab].getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
